export const DEMO_SCHOOL_LEADERBOARD_EMAIL = 'demo@snowsproam.com';
export const isDemoSchoolLeaderboard = (email, type) =>
  String(email || '').toLowerCase() === DEMO_SCHOOL_LEADERBOARD_EMAIL
  && String(type || '').toLowerCase() === 'school';

export const buildDemoSchoolLeaderboard = ({ realRows = [] } = {}) => {
  const byWorkspace = new Map();
  realRows.forEach((row) => {
    if (!row?.id || row.is_active === false || row.archived_at || row.has_teams || row.teams) return;
    const key = row.workspace_id || row.id;
    if (byWorkspace.has(key)) return;
    const imageUrl = row.workspace_logo_url || row.brand_logo_url || row.image_url || '';
    byWorkspace.set(key, {
      ...row,
      name: row.name,
      type: 'School',
      institute_type: 'School',
      region: row.state_province,
      image: imageUrl,
      image_url: imageUrl,
      totalSteps: Number(row.total_steps ?? row.totalSteps) || 0,
      accessLocked: false,
    });
  });
  return [...byWorkspace.values()]
    .sort((a, b) => b.totalSteps - a.totalSteps || a.name.localeCompare(b.name))
    .map((row, index) => ({ ...row, rank: index + 1 }));
};
